export default "__VITE_ASSET__CNUN1yv9__"